module.exports = __webpack_public_path__ + "img/instagram--green.ed312d9f.svg";